import { Popover, PopoverPosition } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { EstateTaskInstance } from 'queries';

import EstateTaskInstanceCustomDeadlineForm from './estate-task-instance-custom-deadline-form';

const useStyles = makeStyles(() => ({
  popoverContents: {
    width: '250px', // popover using fixed width so that absolute anchoring is consistent on different screen sizes
  },
}));

type Props = {
  estateTaskInstance: EstateTaskInstance;
  anchorPosition: PopoverPosition;
  // eslint-disable-next-line @typescript-eslint/ban-types
  replaceEstateTaskInstance: Function;
  onClose: () => void;
};

export default function EstateTaskInstanceCustomDeadlinePopover({
  estateTaskInstance,
  anchorPosition,
  replaceEstateTaskInstance,
  onClose,
}: Props) {
  const classes = useStyles();

  return (
    <Popover
      id={`popover_${estateTaskInstance.id}`}
      open={true}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <div className={classes.popoverContents}>
        <EstateTaskInstanceCustomDeadlineForm
          estateTaskInstance={estateTaskInstance}
          replaceEstateTaskInstance={replaceEstateTaskInstance}
          onClose={onClose}
        />
      </div>
    </Popover>
  );
}
